module.exports = __webpack_public_path__ + "img/domicile.f609f124.jpg";